import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { Moon, Sun, Monitor } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function ThemeToggle({ className }) {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  const Icon = !mounted ? Moon : resolvedTheme === "light" ? Sun : Moon;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={className || "h-8 w-8 rounded-md text-muted-foreground hover:text-foreground"}
          data-testid="theme-toggle"
          aria-label="Toggle theme"
        >
          <Icon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[8.5rem]">
        <DropdownMenuItem data-testid="theme-light" onClick={() => setTheme("light")}>
          <Sun className="h-3.5 w-3.5 mr-2" /> Light {theme === "light" ? "·" : ""}
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="theme-dark" onClick={() => setTheme("dark")}>
          <Moon className="h-3.5 w-3.5 mr-2" /> Dark {theme === "dark" ? "·" : ""}
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="theme-system" onClick={() => setTheme("system")}>
          <Monitor className="h-3.5 w-3.5 mr-2" /> System {theme === "system" ? "·" : ""}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
